function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8 11a3 3 0 1 1 3-3 3 3 0 0 1-3 3zm0-5a2 2 0 1 0 2 2 2 2 0 0 0-2-2z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.5 16h-1A1.5 1.5 0 0 1 6 14.5v-.85a5.91 5.91 0 0 1-.58-.24l-.6.6A1.54 1.54 0 0 1 2.7 14l-.7-.7a1.5 1.5 0 0 1 0-2.12l.6-.6a5.91 5.91 0 0 1-.25-.58H1.5A1.5 1.5 0 0 1 0 8.5v-1A1.5 1.5 0 0 1 1.5 6h.85a5.91 5.91 0 0 1 .24-.58L2 4.82A1.5 1.5 0 0 1 2 2.7l.7-.7a1.54 1.54 0 0 1 2.12 0l.6.6A5.91 5.91 0 0 1 6 2.35V1.5A1.5 1.5 0 0 1 7.5 0h1A1.5 1.5 0 0 1 10 1.5v.85a5.91 5.91 0 0 1 .58.24l.6-.6A1.54 1.54 0 0 1 13.3 2l.7.7a1.5 1.5 0 0 1 0 2.12l-.6.6a5.91 5.91 0 0 1 .24.58h.85A1.5 1.5 0 0 1 16 7.5v1a1.5 1.5 0 0 1-1.5 1.5h-.85a5.91 5.91 0 0 1-.24.58l.6.6a1.5 1.5 0 0 1 0 2.12l-.71.7a1.54 1.54 0 0 1-2.12 0l-.6-.6a5.91 5.91 0 0 1-.58.24v.85A1.5 1.5 0 0 1 8.5 16zm-3.27-3.82.33.18a4.94 4.94 0 0 0 1.07.44l.36.1v1.6a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1.59l.36-.1a4.94 4.94 0 0 0 1.07-.44l.33-.18 1.12 1.12a.51.51 0 0 0 .71 0l.71-.71a.5.5 0 0 0 0-.71l-1.12-1.12.18-.33a4.94 4.94 0 0 0 .44-1.07l.1-.36h1.61a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1.59l-.1-.36a4.94 4.94 0 0 0-.44-1.07l-.18-.33 1.11-1.14a.5.5 0 0 0 0-.71l-.7-.7a.51.51 0 0 0-.71 0l-1.12 1.12-.33-.18a4.94 4.94 0 0 0-1.07-.44L9 3.09V1.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.59l-.36.1a4.94 4.94 0 0 0-1.07.44l-.33.18L4.11 2.7a.51.51 0 0 0-.71 0l-.7.7a.5.5 0 0 0 0 .71l1.12 1.12-.18.33a4.94 4.94 0 0 0-.44 1.07L3.09 7H1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1.59l.1.36a4.94 4.94 0 0 0 .44 1.07l.18.33-1.11 1.13a.5.5 0 0 0 0 .71l.71.71a.51.51 0 0 0 .71 0z"
}, React.createElement("animateTransform", {
  attributeName: "transform",
  begin: "0s",
  dur: "3s",
  type: "rotate",
  from: "0 8 8",
  to: "360 8 8",
  repeatCount: "indefinite"
}));

var SvgConstruction = function SvgConstruction(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 16 16",
    width: 35,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConstruction, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/construction.908bf4c6.svg";
export { ForwardRef as ReactComponent };